var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeart = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#B2B2B2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M12.052 7c-.624-.818-1.278-1.584-2.15-2.142l-.12-.074c-1.574-.955-3.517-1.099-5.12-.12-.64.39-1.18.937-1.57 1.577-.98 1.606-.68 3.476.147 5.081.743 1.438 1.808 2.695 2.928 3.85 1.63 1.68 3.987 3.372 5.88 4.748 1.892-1.376 4.31-3.069 5.94-4.748 1.122-1.155 2.187-2.412 2.929-3.85.828-1.605 1.126-3.475.147-5.081-.389-.64-.93-1.188-1.57-1.577-1.603-.979-3.546-.835-5.12.12l-.119.074c-.872.558-1.579 1.324-2.202 2.142z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/heart.67ee7873a5899d069e47e63846ca6e75.svg";